module.exports = __webpack_public_path__ + "img/157-133655.png";